<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" 
            @tab-click="handleClick" v-if="showWYBG && showZHSZBG && showCSSZ">
            <!-- <el-tab-pane label="五育报告" name="first">
                <child1></child1>
            </el-tab-pane> -->
            <el-tab-pane label="综合素养报告" name="first">
                <child2></child2>    
            </el-tab-pane>

            <el-tab-pane label="参数设置" name="second">
                <child3></child3>    
            </el-tab-pane>
        </el-tabs>

        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" 
            @tab-click="handleClick" v-else-if="showWYBG">
            <el-tab-pane label="综合素养报告" name="first">
                <child2></child2>    
            </el-tab-pane>
        </el-tabs>  
    </div>
</template>

<script>
    import complexQualityReport from './ComplexQualityReport'
    import reportConfig from './ReportConfig'

    export default {
        name:"ComplexMain",
        components:{
            child2:complexQualityReport,
            child3:reportConfig,
        },
        data() {
            return {
                menuName:"",
                showWYBG:false,
                showZHSZBG:false,
                showCSSZ:false,
                //默认第一个选项卡
                activeName:"first",
                title: "",
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            let userInfo=JSON.parse(sessionStorage.getItem('userinfo'))

            if(userInfo.id === "1"){ // 管理员
                this.showWYBG=true;
                this.showZHSZBG=true;
                this.showCSSZ=true;
            }else{ 
                this.showWYBG=true;
                this.showZHSZBG=false;
                this.showCSSZ=false;
            }
            this.title = "综合素养报告";
            console.log(this.showWYBG+"；"+this.showZHSZBG);

        },
        methods:{
            handleClick(tab) {
                this.title=tab.label;
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/complexMain.vue